module.exports = __webpack_public_path__ + "img/green-check.f4a3fa01.svg";